import { Toast } from 'vant';
import Vue from 'vue'
Vue.prototype.$mobileMessage = function(msg){
  Toast(msg)
}
